import clsx from 'clsx';

import type { CalculatedColumn } from '../types';
import { cellClassname, cellFrozenClassname, cellFrozenLastClassname } from '../style';

export * from './domUtils';
export * from './keyboardUtils';
export * from './selectedCellUtils';

export function assertIsValidKeyGetter<R>(keyGetter: unknown): asserts keyGetter is (row: R) => React.Key {
  if (typeof keyGetter !== 'function') {
    throw new Error('Please specify the rowKeyGetter prop to use selection');
  }
}

export function getCellStyle<R, SR>(column: CalculatedColumn<R, SR>): React.CSSProperties {
  return {
    gridColumnStart: column.idx + 1,
    left: column.frozen ? `var(--frozen-left-${column.key})` : undefined
  };
}

export function getCellClassname<R, SR>(column: CalculatedColumn<R, SR>, ...extraClasses: Parameters<typeof clsx>): string {
  return clsx(
    cellClassname, {
      [cellFrozenClassname]: column.frozen,
      [cellFrozenLastClassname]: column.isLastFrozenColumn
    },
    ...extraClasses
  );
}

/**
 * 生成一个唯一key
 * @param suffixStr key后缀
 */

export const generateUniqKey = (function () {
  let key = 0;
  return function (suffixStr: string = ''): string {
    key = key + 1;
    return `${key}-${Date.now()}-${~~(Math.random() * 10000)}-${suffixStr || ''}`;
  };
})();

export const createNewRow = function (key: string) {
  return {
    [key]: generateUniqKey(),
    _created: true,
  };
};